import Vue from 'vue'
import Router from 'vue-router'
import routes from './route.config'
Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return {
        x: 0,
        y: to.meta.savedPosition || 0
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'BladeX 快速开发平台,官方网站,基于SpringBoot,SpringCloud的微服务快速开发平台',
      component: () => import(/* webpackChunkName: "views" */ './views/Home.vue')
    }, {
      path: '/vip',
      name: '授权',
      component: () => import(/* webpackChunkName: "views" */ './views/Vip.vue')
    }, {
      path: '/market',
      name: '应用市场',
      component: () => import(/* webpackChunkName: "views" */ './views/Market.vue')
    }, {
      path: '/license',
      name: '授权查询',
      component: () => import(/* webpackChunkName: "views" */ './views/License.vue')
    }, {
      path: '/contract',
      name: '联系我们',
      component: () => import(/* webpackChunkName: "views" */ './views/Contract.vue')
    }, {
      path: '/pay',
      name: '支付',
      component: () => import(/* webpackChunkName: "views" */ './views/Pay.vue')
    }, {
      path: '/pay-list',
      name: '支付列表',
      component: () => import(/* webpackChunkName: "views" */ './views/PayList.vue')
    }, {
      path: '/sqs',
      name: '授权书',
      component: () => import(/* webpackChunkName: "views" */ './views/Sqs.vue')
    }, {
      path: '/fp',
      name: '发票管理',
      component: () => import(/* webpackChunkName: "views" */ './views/Fp.vue')
    }, {
      path: '/sf',
      name: '实名管理',
      component: () => import(/* webpackChunkName: "views" */ './views/Sf.vue')
    }, {
      path: '/log',
      name: '日志管理',
      component: () => import(/* webpackChunkName: "views" */ './views/Log.vue')
    }, {
      path: '/user/auth',
      name: '我的授权',
      component: () => import(/* webpackChunkName: "views" */ './views/Authorize.vue')
    }, {
      path: '/user/product',
      name: '我的产品',
      component: () => import(/* webpackChunkName: "views" */ './views/Product.vue')
    }, ...routes]
})
router.afterEach((to) => {
  if (to.path === '/') {
    document.title = to.name
  } else {
    document.title = to.name + ' - BladeX 快速开发平台,官方网站,基于SpringBoot,SpringCloud的微服务快速开发平台';
  }

})
export default router
